// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
// } from "@mui/material";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Navigate, useLocation, useNavigate } from "react-router-dom";
// import { Divider } from "@mui/material";
// import HOST_URL from "../../../utils/Url";
// import Autocomplete from "@mui/material/Autocomplete";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import dayjs from 'dayjs';
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";

// import { IconButton, InputAdornment } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";

// type Props = {};

// const UserManagementEdit = (props: Props) => {

//   const location = useLocation();
//   console.log("location", location.state);
//   const [showPassword, setShowPassword] = useState(false);

//   const { i18n, t } = useTranslation();
//   const [toaster, setToaster] = useState(false);
//   const [option, setOption] = useState([{
//     value: "-1", label:
//       t("text.SelectGender")
//   }]);
//   const [option1, setOption1] = useState([{ value: "-1", label: t("text.SelectRole") }]);
//   const [option2, setOption2] = useState([{ value: "-1", label: t("text.SelectUserType") }]);
//   const [Division, setDivision] = useState<any>([
//     { value: "-1", label: t("text.SelectDepartment") },
//   ])
//   const [subDepartments, setSubDepartments] = useState<any>([]);


//   let navigate = useNavigate();

//   const back = useNavigate();

//   const getGender = () => {
//     const collectData = {
//       genderID: -1,
//     };
//     axios
//       .post(HOST_URL.HOST_URL + `Gender/GetGenderMaster`, collectData)
//       .then((res) => {
//         const arr = [];
//         console.log("result" + JSON.stringify(res.data.data));
//         for (let index = 0; index < res.data.data.length; index++) {
//           arr.push({
//             label: res.data.data[index]["genderName"],
//             value: res.data.data[index]["genderID"],
//           });
//         }
//         setOption(arr);
//       });
//   };
//   const getDivision = () => {
//     const collectData = {
//       id: -1,
//       nodeID: -1,
//       titleID: -1,
//     };
//     axios
//       .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
//       .then((res) => {
//         const arr = res.data.data.map((item: any) => ({
//           label: item.name,
//           value: item.id,
//         }));
//         setDivision(arr);
//       });
//   };
//   const getSubDepartment = (deptId: number = -1) => {
//     const collectData = {
//       "subDeptID": -1,
//       "deptID": deptId

//     };
//     axios
//       .post(HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`, collectData)
//       .then((res) => {
//         const arr =
//           res.data.data.map((item: any) => ({
//             label: item.subDeptName,
//             value: String(item.subDeptID),
//           })) || [];
//         setSubDepartments(arr);
//       })
//       .catch((error) => {
//         console.error("Error fetching divisions:", error);
//         toast.error(t("text.ErrorFetchingDivisions"));
//       });
//   };


//   const getRole = () => {
//     const collectData = {
//       roleId: "-1",
//     };
//     axios
//       .post(HOST_URL.HOST_URL + `RoleMaster/GetRoleMaster`, collectData)
//       .then((res) => {
//         const arr = [];
//         console.log("result" + JSON.stringify(res.data.data));
//         for (let index = 0; index < res.data.data.length; index++) {
//           arr.push({
//             label: res.data.data[index]["roleName"],
//             value: res.data.data[index]["roleId"],
//           });
//         }
//         setOption1(arr);
//       });
//   };

//   const getUserType = () => {
//     const collectData = {
//       useR_TYPE_ID: -1,
//     };
//     axios
//       .post(HOST_URL.HOST_URL + `UserPermission/GetUSER_TYPE`, collectData)
//       .then((res) => {
//         const arr = [];
//         console.log("result" + JSON.stringify(res.data.data));
//         for (let index = 0; index < res.data.data.length; index++) {
//           arr.push({
//             label: res.data.data[index]["useR_TYPE_NAME"],
//             value: res.data.data[index]["useR_TYPE_ID"],
//           });
//         }
//         setOption2(arr);
//       });
//   };

//   useEffect(() => {
//     getRole();
//     getGender();
//     getUserType();
//     getDivision();
//     getSubDepartment();
//   }, []);

//   const validationSchema = Yup.object({
//     firsT_NAME: Yup.string().test(
//       "required",
//       // "First Name Required",
//       t("text.reqFirst"),
//       function (value: any) {
//         return value && value.trim() !== "";
//       }
//     ),
//     suR_NAME: Yup.string().test(
//       "required",
//       // "Last Name Required",
//       t("text.reqLast"),
//       function (value: any) {
//         return value && value.trim() !== "";
//       }
//     ),
//     logiN_NAME: Yup.string().test(
//       "required",
//       // "login ID Required",
//       t("text.reqLogin"),
//       function (value: any) {
//         return value && value.trim() !== "";
//       }
//     ),
//     // password: Yup.string().test(
//     //   "required",
//     //   // "Password Required",
//     //   t("text.reqPassword"),
//     //   function (value: any) {
//     //     return value && value.trim() !== "";
//     //   }
//     // ),
//     cuR_MOBILE: Yup.string()
//       // .required("Mobile Number Required")
//       .required(t("text.reqMobile"))
//       .test(
//         // "is-valid-mobile",
//         t("text.validMobile"),
//         // "Invalid mobile number format",
//         t("text.InvalidMobile"),
//         function (value: any) {
//           const trimmedValue = value.trim();
//           if (trimmedValue && trimmedValue.length === 10) {
//             if (trimmedValue.charAt(0) === '0') {
//               return false;
//             }
//             return true;
//           }
//           return false;
//         }
//       ),
//     email: Yup.string()
//       // .required("Email ID Required")
//       .required(t("text.reqEmail"))
//       .test(
//         // "is-valid-email",
//         t("text.validEmail"),
//         t("text.InvalidEmail"),
//         // "Invalid email format",
//         function (value: any) {
//           const trimmedValue = value.trim();
//           return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedValue);
//         }
//       ),
//     dob: Yup.string().test(
//       "required",
//       // "Date of Birth Required",
//       t("text.reqDate"),
//       function (value: any) {
//         return value && value.trim() !== "";
//       }
//     ),
//     gendeR_ID: Yup.string().test(
//       "required",
//       // "Gender Required",
//       t("text.reqGender"),
//       function (value: any) {
//         return value && value.trim() !== "";
//       }
//     ),
//     useR_TYPE_ID: Yup.string().test(
//       "required",
//       // "User Type Required",
//       t("text.reqUser"),

//       function (value: any) {
//         return value && value.trim() !== "";
//       }
//     ),
//     rolename: Yup.string().test(
//       "required",
//       // "Role Required",
//       t("text.reqRole"),
//       function (value: any) {
//         return value && value.trim() !== "";
//       }
//     ),
//   });

//   const [oldPassword, setOldPassword] = useState(location.state.password);
//   const formik = useFormik({
//     initialValues: {
//       useR_ID: location.state.id,
//       ranK_ID: location.state.ranK_ID,
//       suR_NAME: location.state.suR_NAME,
//       firsT_NAME: location.state.firsT_NAME,
//       middlE_NAME: location.state.middlE_NAME,
//       shorT_NAME: location.state.shorT_NAME,
//       useR_CODE: location.state.useR_CODE,
//       dob: dayjs(location.state.dob).format('YYYY-MM-DD'),
//       doa: dayjs(location.state.doa).format('YYYY-MM-DD'),
//       doj: dayjs(location.state.doj).format('YYYY-MM-DD'),
//       gendeR_ID: location.state.gendeR_ID,
//       cuR_PHONE: location.state.cuR_PHONE,
//       cuR_MOBILE: location.state.cuR_MOBILE,
//       email: location.state.email,
//       iS_ACTIVE: location.state.iS_ACTIVE,
//       iS_DELETED: location.state.iS_DELETED,
//       useR_TYPE_ID: location.state.useR_TYPE_ID,
//       otp: location.state.otp,
//       logiN_NAME: location.state.logiN_NAME,
//       // password: location.state.password,
//       password: "",
//       rolename: location.state.rolename,
//       departmentId: location.state.departmentId,
//       department_Name: location.state.department_Name,
//       subDeptID: location.state.subDeptID,
//       subDept_Name: location.state.subDept_Name
//     },
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       values.doa = "1900-01-01T07:47:27.349Z";
//       values.doj = "1900-01-01T07:47:27.349Z";

//         if (!values.password || values.password.trim() === "") {
//     values.password = oldPassword; // old password send karo
//   }
//       const response = await axios.post(
//         HOST_URL.HOST_URL + `USER/AddUpdateUSER`,
//         values
//       );
//       if (response.data.isSuccess) {
//         setToaster(false);
//         toast.success(response.data.mesg);
//       } else {
//         setToaster(true);
//         toast.error(response.data.mesg);
//       }
//       navigate("/UserManagement/UserManagement");
//     },
//   });

//   const requiredFields = [
//     "firsT_NAME",
//     "suR_NAME",
//     "logiN_NAME",
//     "password",
//     "cuR_MOBILE",
//     "email",
//     "dob",
//     "gendeR_ID",
//     "useR_TYPE_ID",
//     "rolename",
//   ];

//   return (
//     <div>
//       <div
//         style={{
//           padding: "-5px 5px",
//           backgroundColor: "#FFFFFF",
//           borderRadius: "5px",
//           border: ".5px solid #ff7722",
//           marginTop: "3vh"
//         }}
//       >
//         <CardContent>
//           <Typography
//             variant="h5"
//             textAlign="center"
//             style={{ marginTop: "10px", fontSize: "18px", fontWeight: 500 }}
//           >
//             {t("text.EditUserManegment")}
//           </Typography>
//           <Grid xs={4} sm={12} item>
//             <Typography style={{ marginTop: "-75px" }}>
//               <Button
//                 type="submit"
//                 onClick={() => back(-1)}
//                 variant="contained"
//                 style={{
//                   marginBottom: 15,
//                   marginTop: "45px",
//                   backgroundColor: `var(--header-background)`,
//                   width: 20,
//                 }}
//               >
//                 <ArrowBackSharpIcon />
//               </Button>
//             </Typography>
//           </Grid>
//           <Divider />
//           <br />
//           <form onSubmit={formik.handleSubmit}>
//             {toaster === false ? "" : <ToastApp />}
//             <Grid item xs={12} container spacing={2}>
//               <Grid xs={12} sm={4} item>
//                 <TextField
//                   type="text"
//                   label={
//                     <span>
//                       {t("text.EnterFirstName")} {" "}
//                       {requiredFields.includes("firsT_NAME") && (
//                         <span
//                           style={{
//                             color: formik.values.firsT_NAME ? "green" : "red",
//                           }}
//                         >
//                           *
//                         </span>
//                       )}
//                     </span>
//                   }
//                   value={formik.values.firsT_NAME}
//                   name="firsT_NAME"
//                   id="firsT_NAME"
//                   placeholder={t("text.EnterFirstName")}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.firsT_NAME && formik.errors.firsT_NAME ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.firsT_NAME)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid xs={12} sm={4} item>
//                 <TextField
//                   type="text"
//                   label={t("text.EnterMiddleName")}
//                   value={formik.values.middlE_NAME}
//                   name="middlE_NAME"
//                   id="middlE_NAME"
//                   placeholder={t("text.EnterMiddleName")}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </Grid>

//               <Grid xs={12} sm={4} item>
//                 <TextField
//                   type="text"
//                   label={
//                     <span>
//                       {t("text.EnterLastName")} {" "}
//                       {requiredFields.includes("suR_NAME") && (
//                         <span
//                           style={{
//                             color: formik.values.suR_NAME ? "green" : "red",
//                           }}
//                         >
//                           *
//                         </span>
//                       )}
//                     </span>
//                   }
//                   name="suR_NAME"
//                   id="suR_NAME"
//                   value={formik.values.suR_NAME}
//                   placeholder={t("text.EnterLastName")}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.suR_NAME && formik.errors.suR_NAME ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.suR_NAME)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid xs={12} sm={4} item>
//                 <TextField
//                   type="text"
//                   label={
//                     <span>
//                       {t("text.EnterLoginName")}{" "}
//                       {requiredFields.includes("logiN_NAME") && (
//                         <span
//                           style={{
//                             color: formik.values.logiN_NAME ? "green" : "red",
//                           }}
//                         >
//                           *
//                         </span>
//                       )}
//                     </span>
//                   }
//                   name="logiN_NAME"
//                   id="logiN_NAME"
//                   value={formik.values.logiN_NAME}
//                   placeholder={t("text.EnterLoginName")}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.logiN_NAME && formik.errors.logiN_NAME ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.logiN_NAME)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid xs={12} sm={4} item>
//                 <TextField
//                   type={showPassword ? "text" : "password"}
//                   label={
//                     <span>
//                       {t("text.EnterPassword")}{" "}
//                       {requiredFields.includes("password") && (
//                         <span
//                           style={{
//                             color: formik.values.password ? "green" : "red",
//                           }}
//                         >
//                           *
//                         </span>
//                       )}
//                     </span>
//                   }
//                   value={formik.values.password}
//                   name="password"
//                   id="password"
//                   placeholder={t("text.EnterPassword")}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   InputProps={{
//                     endAdornment: (
//                       <InputAdornment position="end">
//                         <IconButton
//                           onClick={() => setShowPassword(!showPassword)}
//                           edge="end"
//                         >
//                           {showPassword ? <VisibilityOff /> : <Visibility />}
//                         </IconButton>
//                       </InputAdornment>
//                     ),
//                   }}
//                 />


//                 {formik.touched.password && formik.errors.password ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.password)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid xs={12} sm={4} item>
//                 <TextField
//                   type="text"
//                   label={t("text.EnterUserCode")}
//                   name="useR_CODE"
//                   id="useR_CODE"
//                   value={formik.values.useR_CODE}
//                   placeholder={t("text.EnterUserCode")}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </Grid>

//               <Grid xs={12} sm={4} item>
//                 <TextField
//                   type="text"
//                   label={
//                     <span>
//                       {t("text.EnterMobileNo")}{" "}
//                       {requiredFields.includes("cuR_MOBILE") && (
//                         <span
//                           style={{
//                             color: formik.values.cuR_MOBILE ? "green" : "red",
//                           }}
//                         >
//                           *
//                         </span>
//                       )}
//                     </span>
//                   }
//                   name="cuR_MOBILE"
//                   id="cuR_MOBILE"
//                   value={formik.values.cuR_MOBILE}
//                   placeholder={t("text.EnterMobileNo")}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.cuR_MOBILE && formik.errors.cuR_MOBILE ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.cuR_MOBILE)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid xs={12} sm={4} item>
//                 <TextField
//                   type="email"
//                   label={
//                     <span>
//                       {t("text.EnterEmailId")}{" "}
//                       {requiredFields.includes("email") && (
//                         <span
//                           style={{
//                             color: formik.values.email ? "green" : "red",
//                           }}
//                         >
//                           *
//                         </span>
//                       )}
//                     </span>
//                   }
//                   name="email"
//                   id="email"
//                   value={formik.values.email}
//                   placeholder={t("text.EnterEmailId")}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.email && formik.errors.email ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.email)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid xs={12} sm={4} item>
//                 <TextField
//                   type="Date"
//                   InputLabelProps={{ shrink: true }}
//                   label={
//                     <span>
//                       {t("text.EnterDateOfBirth")} {" "}
//                       {requiredFields.includes("dob") && (
//                         <span
//                           style={{ color: formik.values.dob ? "green" : "red" }}
//                         >
//                           *
//                         </span>
//                       )}
//                     </span>
//                   }
//                   name="dob"
//                   id="dob"
//                   placeholder={t("text.EnterDateOfBirth")}
//                   value={formik.values.dob}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.dob && formik.errors.dob ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {formik.errors.dob}
//                   </div>
//                 ) : null}
//               </Grid>


//               <Grid item lg={4} sm={3} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={Division}
//                   value={
//                     Division.find(
//                       (option: any) => option.value === formik.values.departmentId
//                     ) || null
//                   }
//                   fullWidth
//                   size="small"
//                   onChange={(event, newValue: any) => {
//                     console.log(newValue?.value);

//                     formik.setFieldValue("departmentId", newValue?.value);
//                     formik.setFieldValue("department_Name", newValue?.label);

//                     formik.setFieldTouched("departmentId", true);
//                     formik.setFieldTouched("departmentId", false);

//                     if (newValue?.value) {
//                       getSubDepartment(Number(newValue?.value || -1))
//                     } else {
//                       getSubDepartment();
//                     }
//                   }}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.SelectDepartment")} {""}

//                         </span>
//                       }
//                     />
//                   )}
//                 />


//               </Grid>

//               <Grid item lg={4} sm={3} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={subDepartments}
//                   // value={
//                   //     ZoneOption.find(
//                   //         (option) => option.value === formik.values.fileTypeId
//                   //     ) || null
//                   // }
//                   fullWidth
//                   size="small"
//                   onChange={(event, newValue: any) => {
//                     console.log(newValue?.value);

//                     formik.setFieldValue("subDeptID", newValue?.value);
//                     formik.setFieldValue("subDept_Name", newValue?.label);

//                     formik.setFieldTouched("subDeptID", true);
//                     formik.setFieldTouched("subDeptID", false);
//                   }}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.SelectSubDept")} {""}

//                         </span>
//                       }
//                     />
//                   )}
//                 />


//               </Grid>

//               <Grid xs={12} sm={4} item>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={option}
//                   fullWidth
//                   size="small"
//                   value={option.find(opt => opt.value === formik.values.gendeR_ID) || null}
//                   onChange={(event, newValue) => {
//                     formik.setFieldValue("gendeR_ID", newValue?.value);
//                     formik.setFieldTouched("gendeR_ID", true);
//                     formik.setFieldTouched("gendeR_ID", false);
//                   }}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.SelectGender")} {""}
//                           {requiredFields.includes("gendeR_ID") && (
//                             <span
//                               style={{
//                                 color: formik.values.gendeR_ID
//                                   ? "green"
//                                   : "red",
//                               }}
//                             >
//                               *
//                             </span>
//                           )}
//                         </span>
//                       }
//                     />
//                   )}
//                 />
//                 {formik.touched.gendeR_ID && formik.errors.gendeR_ID ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.gendeR_ID)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid xs={12} sm={4} item>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={option1}
//                   fullWidth
//                   // value={formik.}
//                   size="small"
//                   value={option1.find(opt => opt.value === formik.values.ranK_ID) || null}
//                   onChange={(event, newValue) => {
//                     formik.setFieldValue("ranK_ID", newValue?.value);
//                     formik.setFieldValue("rolename", newValue?.label);
//                     formik.setFieldTouched("rolename", true);
//                     formik.setFieldTouched("rolename", false);
//                   }}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.SelectRole")} {""}
//                           {requiredFields.includes("rolename") && (
//                             <span
//                               style={{
//                                 color: formik.values.rolename
//                                   ? "green"
//                                   : "red",
//                               }}
//                             >
//                               *
//                             </span>
//                           )}
//                         </span>
//                       }
//                     />
//                   )}
//                 />
//                 {formik.touched.rolename && formik.errors.rolename ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.rolename)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid xs={12} sm={4} item>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={option2}
//                   fullWidth
//                   size="small"
//                   value={option2.find(opt => opt.value === formik.values.useR_TYPE_ID) || null}
//                   onChange={(event, newValue) => {
//                     formik.setFieldValue("useR_TYPE_ID", newValue?.value);
//                     formik.setFieldTouched("useR_TYPE_ID", true);
//                     formik.setFieldTouched("useR_TYPE_ID", false);
//                   }}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.SelectUserType")} {""}
//                           {requiredFields.includes("useR_TYPE_ID") && (
//                             <span
//                               style={{
//                                 color: formik.values.useR_TYPE_ID
//                                   ? "green"
//                                   : "red",
//                               }}
//                             >
//                               *
//                             </span>
//                           )}
//                         </span>
//                       }
//                     />
//                   )}
//                 />
//                 {formik.touched.useR_TYPE_ID && formik.errors.useR_TYPE_ID ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.useR_TYPE_ID)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid xs={12} item>
//                 <div style={{ justifyContent: "space-between", flex: 2 }}>
//                   <Button
//                     type="submit"
//                     variant="contained"
//                     style={{
//                       width: "48%",
//                       backgroundColor: `var(--header-background)`,
//                       margin: "1%",
//                     }}
//                   >
//                     {t("text.update")}
//                   </Button>

//                   <Button
//                     type="reset"
//                     variant="contained"
//                     style={{
//                       width: "48%",
//                       backgroundColor: "#F43F5E",
//                       margin: "1%",
//                     }}
//                     onClick={() => formik.resetForm()}
//                   >
//                     {t("text.reset")}
//                   </Button>
//                 </div>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </div>
//     </div>
//   );
// };
// export default UserManagementEdit;


import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Divider } from "@mui/material";
import HOST_URL from "../../../utils/Url";
import Autocomplete from "@mui/material/Autocomplete";
import { useFormik } from "formik";
import * as Yup from "yup";
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

type Props = {};

const UserManagementEdit = (props: Props) => {

  const location = useLocation();
  console.log("location", location.state);
  const [showPassword, setShowPassword] = useState(false);
  const { i18n, t } = useTranslation();
  const [toaster, setToaster] = useState(false);
  const [option, setOption] = useState([{
    value: "-1", label:
      t("text.SelectGender")
  }]);
  const [option1, setOption1] = useState([{ value: "-1", label: t("text.SelectRole") }]);
  const [option2, setOption2] = useState([{ value: "-1", label: t("text.SelectUserType") }]);
  const [Division, setDivision] = useState<any>([
    { value: "-1", label: t("text.SelectDepartment") },
  ])
  const [subDepartments, setSubDepartments] = useState<any>([]);
  const [employeeList, setEmployeeList] = useState<any[]>([]);
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);

  let navigate = useNavigate();
  const back = useNavigate();

  // Fetch Employee List
  const getEmployeeList = () => {
    const collectData = {
      empid: -1,
      userId: "-1",
      empName: "",
      empMobileNo: "",
      empPincode: 0,
      roleId: "-1",
      empDesignationId: -1,
      empDeptId: -1,
      empStateId: -1,
      empCountryID: -1,
      empCityId: -1
    };
    axios
      .post(HOST_URL.HOST_URL + `EmpMaster/GetEmpmaster`, collectData)
      .then((res) => {
        if (res.data.isSuccess && res.data.data) {
          const arr = res.data.data.map((item: any) => ({
            label: `${item.empName} (${item.empCode})`,
            value: item.empid,
            ...item
          }));
          setEmployeeList(arr);
        }
      })
      .catch((error) => {
        console.error("Error fetching employees:", error);
        toast.error(t("text.ErrorFetchingEmployees"));
      });
  };

  const getGender = () => {
    const collectData = {
      genderID: -1,
    };
    axios
      .post(HOST_URL.HOST_URL + `Gender/GetGenderMaster`, collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["genderName"],
            value: res.data.data[index]["genderID"],
          });
        }
        setOption(arr);
      });
  };

  const getDivision = () => {
    const collectData = {
      id: -1,
      nodeID: -1,
      titleID: -1,
    };
    axios
      .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          label: item.name,
          value: item.id,
        }));
        setDivision(arr);
      });
  };

  const getSubDepartment = (deptId: number = -1) => {
    const collectData = {
      "subDeptID": -1,
      "deptID": deptId
    };
    axios
      .post(HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`, collectData)
      .then((res) => {
        const arr =
          res.data.data.map((item: any) => ({
            label: item.subDeptName,
            value: String(item.subDeptID),
          })) || [];
        setSubDepartments(arr);
      })
      .catch((error) => {
        console.error("Error fetching divisions:", error);
        toast.error(t("text.ErrorFetchingDivisions"));
      });
  };

  const getRole = () => {
    const collectData = {
      roleId: "-1",
    };
    axios
      .post(HOST_URL.HOST_URL + `RoleMaster/GetRoleMaster`, collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["roleName"],
            value: res.data.data[index]["roleId"],
          });
        }
        setOption1(arr);
      });
  };

  const getUserType = () => {
    const collectData = {
      useR_TYPE_ID: -1,
    };
    axios
      .post(HOST_URL.HOST_URL + `UserPermission/GetUSER_TYPE`, collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["useR_TYPE_NAME"],
            value: res.data.data[index]["useR_TYPE_ID"],
          });
        }
        setOption2(arr);
      });
  };

  useEffect(() => {
    getRole();
    getGender();
    getUserType();
    getDivision();
    getSubDepartment();
    getEmployeeList();
  }, []);

  useEffect(() => {
    if (location.state?.empId && employeeList.length > 0) {
      const emp = employeeList.find(e => e.value === location.state.empId);
      if (emp) {
        setSelectedEmployee(emp);

        // ✅ Also set form values when employee is loaded from location.state
        formik.setFieldValue("firsT_NAME", emp.empName?.split(' ')[0] || "");
        formik.setFieldValue("suR_NAME", emp.empName?.split(' ').slice(1).join(' ') || "");
        formik.setFieldValue("cuR_MOBILE", emp.empMobileNo || "");
        formik.setFieldValue("email", emp.email || "");
        formik.setFieldValue("gendeR_ID", Number(emp.gender) || "");
        formik.setFieldValue("dob", emp.empDob ? emp.empDob.split('T')[0] : "");
        formik.setFieldValue("empId", emp.empid || 0);
        formik.setFieldValue("empName", emp.empName || "");
        formik.setFieldValue("useR_CODE", emp.empCode || "");
        formik.setFieldValue("departmentId", emp.empDeptId || 0);
        formik.setFieldValue("department_Name", emp.departmentName || "");

        if (emp.empDeptId) {
          getSubDepartment(Number(emp.empDeptId));
          setTimeout(() => {
            formik.setFieldValue("subDeptID", emp.subDeptId || 0);
            formik.setFieldValue("subDept_Name", emp.subDepartmentName || "");
          }, 300);
        }
      }
    }
  }, [employeeList]);
  const validationSchema = Yup.object({
    firsT_NAME: Yup.string().test(
      "required",
      t("text.reqFirst"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    suR_NAME: Yup.string().test(
      "required",
      t("text.reqLast"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    logiN_NAME: Yup.string().test(
      "required",
      t("text.reqLogin"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    cuR_MOBILE: Yup.string()
      .required(t("text.reqMobile"))
      .test(
        t("text.validMobile"),
        t("text.InvalidMobile"),
        function (value: any) {
          const trimmedValue = value.trim();
          if (trimmedValue && trimmedValue.length === 10) {
            if (trimmedValue.charAt(0) === '0') {
              return false;
            }
            return true;
          }
          return false;
        }
      ),
    email: Yup.string()
      .required(t("text.reqEmail"))
      .test(
        t("text.validEmail"),
        t("text.InvalidEmail"),
        function (value: any) {
          const trimmedValue = value.trim();
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedValue);
        }
      ),
    dob: Yup.string().test(
      "required",
      t("text.reqDate"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    gendeR_ID: Yup.string().test(
      "required",
      t("text.reqGender"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    useR_TYPE_ID: Yup.string().test(
      "required",
      t("text.reqUser"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    rolename: Yup.string().test(
      "required",
      t("text.reqRole"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
  });

  const [oldPassword, setOldPassword] = useState(location.state.password);

  const formik = useFormik({
    initialValues: {
      useR_ID: location.state.id,
      ranK_ID: location.state.ranK_ID,
      suR_NAME: location.state.suR_NAME,
      firsT_NAME: location.state.firsT_NAME,
      middlE_NAME: location.state.middlE_NAME,
      shorT_NAME: location.state.shorT_NAME,
      useR_CODE: location.state.useR_CODE,
      dob: dayjs(location.state.dob).format('YYYY-MM-DD'),
      doa: dayjs(location.state.doa).format('YYYY-MM-DD'),
      doj: dayjs(location.state.doj).format('YYYY-MM-DD'),
       gendeR_ID: Number(location.state.gendeR_ID) || "",
      cuR_PHONE: location.state.cuR_PHONE,
      cuR_MOBILE: location.state.cuR_MOBILE,
      email: location.state.email,
      iS_ACTIVE: location.state.iS_ACTIVE,
      iS_DELETED: location.state.iS_DELETED,
      useR_TYPE_ID: location.state.useR_TYPE_ID,
      otp: location.state.otp,
      logiN_NAME: location.state.logiN_NAME,
      password: "",
      rolename: location.state.rolename,
      departmentId: location.state.departmentId,
      department_Name: location.state.department_Name,
      subDeptID: location.state.subDeptID,
      subDept_Name: location.state.subDept_Name,
      empId: location.state.empId || 0,      // ✅ Add empId
      empName: location.state.empName || ""   // ✅ Add empName
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      values.doa = "1900-01-01T07:47:27.349Z";
      values.doj = "1900-01-01T07:47:27.349Z";

      if (!values.password || values.password.trim() === "") {
        values.password = oldPassword;
      }
      const response = await axios.post(
        HOST_URL.HOST_URL + `USER/AddUpdateUSER`,
        values
      );
      if (response.data.isSuccess) {
        setToaster(false);
        toast.success(response.data.mesg);
        navigate("/UserManagement/UserManagement");
      } else {
        setToaster(true);
        toast.error(response.data.mesg);
      }
    },
  });

  // Handle Employee Selection
  const handleEmployeeSelect = (event: any, newValue: any) => {
    setSelectedEmployee(newValue);

    if (newValue) {
      formik.setFieldValue("firsT_NAME", newValue.empName?.split(' ')[0] || "");
      formik.setFieldValue("suR_NAME", newValue.empName?.split(' ').slice(1).join(' ') || "");
      formik.setFieldValue("cuR_MOBILE", newValue.empMobileNo || "");
      formik.setFieldValue("email", newValue.email || "");
      formik.setFieldValue("gendeR_ID", Number(newValue.gender) || "");
      formik.setFieldValue("dob", newValue.empDob ? newValue.empDob.split('T')[0] : "");

      // ✅ Set empId and empName
      formik.setFieldValue("empId", newValue.empid || 0);
      formik.setFieldValue("empName", newValue.empName || "");
      formik.setFieldValue("useR_CODE", newValue.empCode || "");

      // ✅ Department
      formik.setFieldValue("departmentId", newValue.empDeptId || 0);
      formik.setFieldValue("department_Name", newValue.departmentName || "");

      // ✅ Load SubDept
      if (newValue.empDeptId) {
        getSubDepartment(Number(newValue.empDeptId));

        setTimeout(() => {
          formik.setFieldValue("subDeptID", newValue.subDeptId || 0);
          formik.setFieldValue("subDept_Name", newValue.subDepartmentName || "");
        }, 300);
      }
    }
  };

  const requiredFields = [
    "firsT_NAME",
    "suR_NAME",
    "logiN_NAME",
    "password",
    "cuR_MOBILE",
    "email",
    "dob",
    "gendeR_ID",
    "useR_TYPE_ID",
    "rolename",
  ];

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#FFFFFF",
          borderRadius: "5px",
          border: ".5px solid #ff7722",
          marginTop: "3vh"
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ marginTop: "10px", fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.EditUserManegment")}
          </Typography>
          <Grid xs={4} sm={12} item>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>

              {/* Employee Dropdown - New Field */}
              <Grid xs={12} sm={12} item>
                <Autocomplete
                  disablePortal
                  id="employee-dropdown"
                  options={employeeList}
                  fullWidth
                  size="small"
                  value={selectedEmployee}
                  onChange={handleEmployeeSelect}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectEmployee")} {" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      placeholder={t("text.SearchEmployee")}
                    />
                  )}
                />
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="text"
                  label={
                    <span>
                      {t("text.EnterFirstName")} {" "}
                      {requiredFields.includes("firsT_NAME") && (
                        <span
                          style={{
                            color: formik.values.firsT_NAME ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.firsT_NAME}
                  name="firsT_NAME"
                  id="firsT_NAME"
                  placeholder={t("text.EnterFirstName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.firsT_NAME && formik.errors.firsT_NAME ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.firsT_NAME)}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="text"
                  label={t("text.EnterMiddleName")}
                  value={formik.values.middlE_NAME}
                  name="middlE_NAME"
                  id="middlE_NAME"
                  placeholder={t("text.EnterMiddleName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="text"
                  label={
                    <span>
                      {t("text.EnterLastName")} {" "}
                      {requiredFields.includes("suR_NAME") && (
                        <span
                          style={{
                            color: formik.values.suR_NAME ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  name="suR_NAME"
                  id="suR_NAME"
                  value={formik.values.suR_NAME}
                  placeholder={t("text.EnterLastName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.suR_NAME && formik.errors.suR_NAME ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.suR_NAME)}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="text"
                  label={
                    <span>
                      {t("text.EnterLoginName")}{" "}
                      {requiredFields.includes("logiN_NAME") && (
                        <span
                          style={{
                            color: formik.values.logiN_NAME ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  name="logiN_NAME"
                  id="logiN_NAME"
                  value={formik.values.logiN_NAME}
                  placeholder={t("text.EnterLoginName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.logiN_NAME && formik.errors.logiN_NAME ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.logiN_NAME)}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type={showPassword ? "text" : "password"}
                  label={
                    <span>
                      {t("text.EnterPassword")}{" "}
                      {requiredFields.includes("password") && (
                        <span
                          style={{
                            color: formik.values.password ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.password}
                  name="password"
                  id="password"
                  placeholder={t("text.EnterPassword")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {formik.touched.password && formik.errors.password ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.password)}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="text"
                  label={t("text.EnterUserCode")}
                  name="useR_CODE"
                  id="useR_CODE"
                  value={formik.values.useR_CODE}
                  placeholder={t("text.EnterUserCode")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="text"
                  label={
                    <span>
                      {t("text.EnterMobileNo")}{" "}
                      {requiredFields.includes("cuR_MOBILE") && (
                        <span
                          style={{
                            color: formik.values.cuR_MOBILE ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  name="cuR_MOBILE"
                  id="cuR_MOBILE"
                  value={formik.values.cuR_MOBILE}
                  placeholder={t("text.EnterMobileNo")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.cuR_MOBILE && formik.errors.cuR_MOBILE ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.cuR_MOBILE)}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="email"
                  label={
                    <span>
                      {t("text.EnterEmailId")}{" "}
                      {requiredFields.includes("email") && (
                        <span
                          style={{
                            color: formik.values.email ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  name="email"
                  id="email"
                  value={formik.values.email}
                  placeholder={t("text.EnterEmailId")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.email)}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="Date"
                  InputLabelProps={{ shrink: true }}
                  label={
                    <span>
                      {t("text.EnterDateOfBirth")} {" "}
                      {requiredFields.includes("dob") && (
                        <span
                          style={{ color: formik.values.dob ? "green" : "red" }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  name="dob"
                  id="dob"
                  placeholder={t("text.EnterDateOfBirth")}
                  value={formik.values.dob}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.dob && formik.errors.dob ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.dob}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} sm={3} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={Division}
                  value={
                    Division.find(
                      (option: any) => option.value === formik.values.departmentId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("departmentId", newValue?.value);
                    formik.setFieldValue("department_Name", newValue?.label);
                    formik.setFieldTouched("departmentId", true);
                    formik.setFieldTouched("departmentId", false);
                    if (newValue?.value) {
                      getSubDepartment(Number(newValue?.value || -1))
                    } else {
                      getSubDepartment();
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectDepartment")} {""}
                        </span>
                      }
                    />
                  )}
                />
              </Grid>

              <Grid item lg={4} sm={3} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={subDepartments}
                  value={
                    subDepartments.find(
                      (option: any) => option.value === String(formik.values.subDeptID)
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("subDeptID", newValue?.value);
                    formik.setFieldValue("subDept_Name", newValue?.label);
                    formik.setFieldTouched("subDeptID", true);
                    formik.setFieldTouched("subDeptID", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectSubDept")} {""}
                        </span>
                      }
                    />
                  )}
                />
              </Grid>

              <Grid xs={12} sm={4} item>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={option}
                  fullWidth
                  size="small"
                  value={option.find(opt => opt.value === formik.values.gendeR_ID) || null}
                  onChange={(event, newValue) => {
                    formik.setFieldValue("gendeR_ID", newValue?.value);
                    formik.setFieldTouched("gendeR_ID", true);
                    formik.setFieldTouched("gendeR_ID", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectGender")} {""}
                          {requiredFields.includes("gendeR_ID") && (
                            <span
                              style={{
                                color: formik.values.gendeR_ID
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.gendeR_ID && formik.errors.gendeR_ID ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.gendeR_ID)}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={option1}
                  fullWidth
                  size="small"
                  value={option1.find(opt => opt.value === formik.values.ranK_ID) || null}
                  onChange={(event, newValue) => {
                    formik.setFieldValue("ranK_ID", newValue?.value);
                    formik.setFieldValue("rolename", newValue?.label);
                    formik.setFieldTouched("rolename", true);
                    formik.setFieldTouched("rolename", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectRole")} {""}
                          {requiredFields.includes("rolename") && (
                            <span
                              style={{
                                color: formik.values.rolename
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.rolename && formik.errors.rolename ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.rolename)}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={option2}
                  fullWidth
                  size="small"
                  value={option2.find(opt => opt.value === formik.values.useR_TYPE_ID) || null}
                  onChange={(event, newValue) => {
                    formik.setFieldValue("useR_TYPE_ID", newValue?.value);
                    formik.setFieldTouched("useR_TYPE_ID", true);
                    formik.setFieldTouched("useR_TYPE_ID", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectUserType")} {""}
                          {requiredFields.includes("useR_TYPE_ID") && (
                            <span
                              style={{
                                color: formik.values.useR_TYPE_ID
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.useR_TYPE_ID && formik.errors.useR_TYPE_ID ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.useR_TYPE_ID)}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} item>
                <div style={{ justifyContent: "space-between", flex: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{
                      width: "48%",
                      backgroundColor: `var(--header-background)`,
                      margin: "1%",
                    }}
                  >
                    {t("text.update")}
                  </Button>

                  <Button
                    type="reset"
                    variant="contained"
                    style={{
                      width: "48%",
                      backgroundColor: "#F43F5E",
                      margin: "1%",
                    }}
                    onClick={() => formik.resetForm()}
                  >
                    {t("text.reset")}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};
export default UserManagementEdit;